import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css, type CSSResult } from 'lit'

export const style: CSSResult = css`
  :host {
    --cse-expandable-list-row-gap: ${csSpacing.spacing05};
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
  }

  :host cse-expandable {
    text-align: left;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: var(--csc-delivery-match-method-group-gap, ${csSpacing.spacing05});
  }

  .wrapper {
    --cse-radio-button-gap: ${csSpacing.spacing06};
  }

  .group-name {
    display: flex;
    align-items: center;
    gap: ${csSpacing.spacing04}
  }

  .caption-delivery {
    --cs-font-body-color: var(--csc-delivery-match-method-group-delivery-caption-color);
  }

  .caption-dropoff {
    --cs-font-body-color: var(--csc-delivery-match-method-group-dropoff-caption-color);
  }
`
